import { Cluster, Renderer } from '@googlemaps/markerclusterer';

export class CustomerRendererCluster implements Renderer {
  constructor(private thisWindow: Window) {}

  public render({ count, position }: Cluster): google.maps.Marker {
    const svg = this.thisWindow.btoa(`
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="19" fill="#FAF8F4" stroke="#011936" stroke-width="2"/>
      </svg>
    `);

    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(40, 40), // @TODO: Ajout du responsive pour la size (desk: 4rem, mob: 2.4rem)
      },
      label: {
        text: String(count),
        fontWeight: '700',
        color: '#1A1A1AE5',
        fontSize: '1.6rem', // @TODO: Ajout du responsive pour la font-size (desk: 1.6rem, mob: 1.2rem)
        fontFamily: 'Inter, Inter-fallback, sans-serif',
      },
      title: `Cluster de ${count} points`,
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) - count,
    });
  }
}
